import Crezu from '@/utils/'

export const successRedirectPrepare = function ({ state, commit, dispatch }, event) {
  console.log('successRedirectPrepare', event)
  window.onbeforeunload = null
  let gaEventName = (event === 'API') ? 'APISubmitted' : 'feedSubmitted'
  dispatch('pushFBEvent', { track: 'track', event: 'CompleteRegistration', data: { status: state.leadStatus } })
  dispatch('pushFBEvent', { track: 'trackCustom', event: event, data: { status: state.leadStatus } })
  dispatch('pushGAEvent', 'formFillingHistorySuccess')
  dispatch('pushCustomEvent', { name: gaEventName })

  if (event === 'API') { // feedSubmitted will be reported on /offers/ page. So we prevent duplication
    dispatch('pushGAEvent', gaEventName)
    dispatch('sendCrezuEvent', { id: 8 })
    dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'redirectAPI' } })
  }

  //  API_SUBMITTED = 8
  //  FEED_SUBMITTED = 9

  // fire Zuko success trigger
  // let slug = ''
  // if (window.location.hostname === 'pezetita.com') slug = '52415a1be8b0a30b'
  // try {
  //   window.Zuko = window.Zuko || { trackForm: () => { return { trackEvent: () => {} } } }
  //   window.Zuko.trackForm({ slug: slug }).trackEvent(window.Zuko.COMPLETION_EVENT)
  // } catch (e) { console.log(e) }
}

export const openLink = function (url) {
  const isApp = Crezu.common.getURLParameter('is_app') === 'true'
  if (isApp) {
    try {
      window.flutter_inappwebview.callHandler('openExternalLink', url)
    } catch (error) {
      console.error('Error on opening link by app function, trying default opening.', error)
      window.location.href = url
    }
  } else window.location.href = url
}

export const proceedRedirect = function ({ state, commit, dispatch }, res) {
  const leadId = state.additionalParams.lead_id.split('-').join('') || localStorage.getItem('leadId')
  const country = +state.additionalParams.country
  const [schema, address] = res.redirect_url.split('://')
  const redirectUrl = `https://crezu.net:8002/session` +
    `?domain=${window.location.hostname}` +
    `&country_id=${country}` +
    `&lead_id=${leadId}` +
    `&type=1` +
    `&method=api_redirect` +
    `&schema=${schema}` +
    `&pq=${address}`

  let defParams = {
    // logo: (window.location.hostname.startsWith('crezu') || window.location.hostname === 'localhost') ? 'https://cdn.crezu.net/iframe/pic/crezu.png' : '',
    lenderLogo: `${res.logo_url}`,
    redirectUrl,
    header: '¡Tu solicitud ha sido aceptada!',
    subheader: 'Serás redirigido al sitio web de la entidad financiera, que ha aceptado la solicitud, en 5 segundos.',
    button: 'Haz clic para continuar',
    timeout: 5000,
    amountHint: 'Monto del préstamo solicitado',
    amount: res.loan_sum,
    currency: '€'
  }
  if (window.isIframe) {
    defParams.timeout = 600000
    if (country === 2) defParams.currency = '$'
    commit('CHANGE_PRELOADER', false)
    commit('SHOW_REDIRECT_POPUP', defParams)
  } else if (country === 1) {
    // customization for Creditosi
    if (+res.lender_id === 187) {
      let amount = +res.loan_sum || 300
      defParams.header = 'Felicidades! ¡CreditoSi ha preaprobado tu préstamo!'
      defParams.subheader = 'Serás redirigido a su web para verificar tu teléfono móvil y añadir tu banca electrónica.  Estos son los costes finales:'
      defParams.button = 'Haz click para aceptar y continuar'
      defParams.amountHint = 'Importe aprobado'
      defParams.amountAdditional = ''
      let creditosiAmountAdditional = [
        { label: 'Intereses', value: '€' + (amount * 0.25).toFixed(0) },
        { label: 'Apertura', value: '€' + (amount * 0.1).toFixed(0) }
      ]
      for (let i in creditosiAmountAdditional) {
        defParams.amountAdditional += `<p class="squeeze-block__cash">${creditosiAmountAdditional[i].label}: <span id="squeeze-block__cash">${creditosiAmountAdditional[i].value}</span></p>`
      }
    }
    // customization for Fidinda
    if (+res.lender_id === 327) {
      defParams.period = `${res.loan_period} días`
      defParams.periodHint = 'Período'
    }
    // customization for Mycredit
    if (+res.lender_id === 116) {
      console.log('simple redirect for Mycredit')
      dispatch('successRedirectPrepare', 'API')
      openLink(redirectUrl)
      return
    }
    commit('CHANGE_PRELOADER', false)
    commit('SHOW_REDIRECT_POPUP', defParams)
  } else if (country === 2 && +res.lender_id === 195) { // customization for Creditea MX
    defParams.currency = '$'
    defParams.additionalText = 'Por este conducto autorizo expresamente a IPF Digital México S.A. de C.V., para que por conducto de sus funcionarios facultados lleve a cabo investigaciones sobre mi comportamiento crediticio en las Sociedades de Información Crediticia que estime conveniente. Así mismo, declaro que conozco la naturaleza y alcance de la información que se solicitara, del uso que IPF Digital México S.A. de C.V. hará de tal información y de que esta podrá realizar consultas periódicas de mi historial crediticio, consintiendo que esta autorización se encuentra vigente por un periodo de 3 años contados a partir de la fecha de su expedición y en todo caso durante el tiempo que mantengamos relación jurídica.*'
    defParams.timeoutToProcessRequest = 20000
    defParams.buttonToProcessRequest = 'Saltar esta oferta y continuar con la selección'
    // defParams.disableAutoRedirect = true
    defParams.subheader = ''
    // defParams.checkbox = 'Acepto que se consulte mi historial crediticio en las Sociedades de Información Crediticia'
    defParams.amountHint = 'Monto de prestamo preaprobado'
    defParams.amount = res.approved_amount
    commit('CHANGE_PRELOADER', false)
    commit('SHOW_REDIRECT_POPUP', defParams)
  } else if (country === 2 && +res.lender_id === 54) { // Lendon MX
    defParams.currency = '$'
    defParams.additionalText = '<span style="font-size: 14px; color: black"> Para finalizar su solicitud, es necesario fotografear su credencial de elector INE, en ambos lados.</span>'
    commit('CHANGE_PRELOADER', false)
    commit('SHOW_REDIRECT_POPUP', defParams)
  } else {
    // simple Redirect
    dispatch('successRedirectPrepare', 'API')
    openLink(redirectUrl)
  }
  // else if (handlePlTransition(state, res.lender_id)) {
  //   const data = {
  //     lenderLogo: res.logo_url,
  //     redirectUrl
  //   }
  //   sessionStorage.setItem('redirectData', JSON.stringify(data))
  //   dispatch('successRedirectPrepare', 'API') // this is mandatory for redirect without alert (are you sere to leave the page?)
  //   // window.location.href = '/transition'
  //   try { window.open('/transition/', '_blank') } catch (e) {
  //     console.log(e)
  //   }
  //   commit('CHANGE_PRELOADER', false)
  //   commit('SHOW_REDIRECT_POPUP', {
  //     isToProcessPopup: true,
  //     header: 'Witaj ponownie!',
  //     subheader: 'Aby kontynuować Twój wniosek, <a>kliknij tutaj</a>',
  //     button: 'Kontynuuj'
  //   })
  // }
}

const handlePlTransition = ({ state, commit, dispatch }, lenderId) => {
  const hostnamesWithTransition = ['cashspace.pl', 'crezu.pl', 'localhost'] // ['cashspace.pl', 'crezu.pl', 'crezu.com.pl', 'localhost']
  if (!hostnamesWithTransition.includes(window.location.hostname)) return false

  const transitionFlow = localStorage.getItem('transitionFlow')
  let flow = null
  if (transitionFlow === null) { // create flow
    flow = +(Math.random() > 0.5)
    localStorage.setItem('transitionFlow', `${flow}`)
  } else { // reuse flow
    flow = +transitionFlow
  }

  dispatch('sendCrezuEvent', { id: 11, data: { sub2: flow, sub3: `${lenderId}` } })

  return !!flow
}



// WEBPACK FOOTER //
// ./src/store/helpers/redirect-actions.js